<template>
    <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
      <header-component :headerTitle="headerText" />
      <FileUploadDialog v-model="showDialog" :api-url="uploadApi" :data="uploadData" />
      <v-snackbar
      v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3 ml-2" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
     <v-card class="v-card-100 mt-0">
        <v-card-title class="action-style pt-4 pb-6">
            <!-- Search fields -->
            <v-row class="ma-1">
                <v-text-field prepend-inner-icon="mdi-magnify" v-model="search_tag" label="Search" class="mr-4"
                    style="max-width: 270px;max-height:52px" variant="outlined" color="primary" @keyup.enter="loadData('search')"></v-text-field>
                    <v-autocomplete class="text-left"  style="max-width: 270px;max-height:52px" v-model="rule_type" :items="rule_type_items" item-title="display_name" item-value="rule_type" label="Select Approval Instance" hide-details variant="outlined" @update:model-value="loadData('rule_type')"> </v-autocomplete>
                <v-spacer></v-spacer>
                <v-actions>
                  <v-btn class="mr-2 text-none" variant="flat" :disabled="selected.length === 0" @click="downloadFile" color="primary" size="x-large">Download</v-btn>
                  <v-btn class="mr-2 pt-0 text-none" :disabled="!rule_type" size="x-large" variant="flat" color="primary" @click="openDialog">Upload</v-btn>           
                  <v-btn class="mr-2 pt-0 text-none" :disabled="!rule_type" size="x-large" @click="fetchApprovalRules" variant="flat" color="primary">View Rule</v-btn>
                </v-actions>
            </v-row>
        </v-card-title>        
      </v-card>
      <div class="v-card-100 mt-0 approval-instance">
        <span>Approval Instance: <span class="font-weight-bold">{{ toTitleCase(rule_type) }}</span></span>
      </div>
      <v-layout column>
        <v-data-table 
            hover
            density="compact"
            :search="search"
            v-model="selected"
            show-select
            disable-pagination
            :hide-default-footer="true"
            :headers="headers"
            :items="table_data"
            :loading="loading"
            :items-per-page="pageSize"
            fixed-header
            height="100%"
            loading-text="Loading Data... Please wait" 
            class="elevation-1"
            return-object
            >
            <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
                <span v-if="header.key == 'action'">
                    <v-icon color="primary">mdi-pencil-outline</v-icon>
                </span> 
                <span v-else-if="header.key !== 'imags' && item[header.key]">
                    <span v-tooltip="item[header.key]">
                    {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                    </span>
                </span>
                <span v-else>-</span>
                </template>
                <template
                    v-for="key in Object.keys(table_data[0]?.approval_details || {})"
                    v-slot:[`item.approval_details.${key}`]="{ item }" :key="key">
                    {{ item.approval_details?.[key] || '-' }}
                </template>
            <template #bottom></template>
        </v-data-table>
    </v-layout>
    <!-- pagination display -->
     <PaginationComponent
             :pageSize="pageSize"
             :pageSizes="pageSizes"
             :totalCount="totalCount"
             :selected="selected"
             :page="page"
             :totalPages="totalPages"
             @update:pageSize="handlePageSizeChange"
             @update:page="handlePageChange"
             class="mt-2 mb-2"
          />
    </v-card>
</template>
<script setup>
    import { ref, reactive, onMounted, getCurrentInstance } from 'vue';
    import HeaderComponent from '../../../commoncomponents/HeaderComponent.vue';
    import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
    import FileUploadDialog from '@/components/commoncomponents/FileUploadDialog.vue';
    import { useStore } from "vuex";
    import { useRouter, useRoute } from 'vue-router' 
    const store = useStore();
    const router = useRouter();
    const route = useRoute();   
    const { proxy } = getCurrentInstance();
    const headerText = ref("Create New Approval Config");
    const snackbar = reactive( {
        color: null,
        icon: null,
        mode: null,
        position: "top",
        text: null,
        timeout: 7500,
        title: null,
        visible: false
      });
    const search_tag = ref('');
    const rule_type = ref(null);
    const rule_type_items = ref([]);
    const selected = ref([]);
    const table_data = ref([]);
    const loading = ref(false);
    const headers = ref([ 
            { title: `Matrix ID`, key: "id", minWidth: "200px" },
            { title: "Matrix Name", key: "matrix_name", minWidth: "150px" },
            { title: "Matrix By", key: "initiator", key: "mobile_number", minWidth: "150px" },
            { title: "Approval Type", key: "approval_type", minWidth: "150px" },
            ]);
    const search = ref('');
    const page = ref(1);
    const pageSize = defaultPageSize;
    const pageSizes = defaultPageSizes;
    const totalCount = ref(0);
    const totalPages = ref(1);
    const showDialog = ref(false);
    const uploadApi = ref('');
    const uploadData = reactive({
        master_file_type: "",
        file_type_name: "",
        header_text: "",
        approval_type:"",
        hide_exist_action: true,
        sample_file_url: ""
        });


    onMounted(() => {
        fetchApprovalInstanceList();
    });

    const loadData = () => {
        loading.value = true;
        selected.value = [];
        table_data.value = [];
        page.value = 1;
        totalPages.value = 1;
        
        const params = {
            page: page.value,
            per_page: pageSize.value,
            approval_type: rule_type.value
        }
        if(search_tag.value != '') {
            params.search = search_tag.value
        }
        proxy.$httpSecured
        .get("/api/v2/approval_matrix", { params })
        .then(response => {
          if(response.data) {
            const rows = response.data.approval_matrices;

            table_data.value = rows;
            // ✅ collect unique approval_details keys
            const allApprovalKeys = new Set();
            rows.forEach((row) => {
                if(row.approval_details) {
                    Object.keys(row.approval_details).forEach((key) => {
                        if(!key.startsWith("All or Any"))
                        allApprovalKeys.add(key);
                    })
                }
            })

            // ✅ add only unique approval headers
            allApprovalKeys.forEach((key) => {
                headers.value.push({
                title: key,
                key: `approval_details.${key}`,
                minWidth: "150px",
                });
            });            
            totalPages.value = response.data.meta.total_pages;
            totalCount.value = response.data.meta.total_count;
            loading.value = false;
          }else{
            loading.value = false;
            proxy.$toast.error("No Data Found");
          }
        })
        .catch(error => {
            loading.value = false;
            proxy.$toast.error(error.response.data.message);
        })
    }

    const fetchApprovalInstanceList = () => {
        // const api = "api/v2/approval_matrix/get_approval_instance_types";
        const api = "api/v2/rule_engine/rule_engine_configurations/get_rule_types?category=approval";
        proxy.$httpSecured.get(api)
        .then(response => {
            if(response.data) {
                rule_type_items.value = response.data;
            }else{
                proxy.$toast.error("No Data Found");
            }
        })
        .catch(error => {
            proxy.$toast.error(error.response.data.message);
        })        
        
    }
    const fetchApprovalRules = () => {
         store.commit("setLotIds", {
          lotIds: headerText.value,
          inventoryId: toTitleCase(rule_type.value),
          action:'first_tab'
        });
        router.push({ name: "ViewRules" });
    }
    const openDialog = () => {
        showDialog.value = true;
        uploadApi.value = "/admin/master_file_uploads";
        uploadData.master_file_type = "Approval Matrix";
        uploadData.file_type_name = rule_type.value;
        uploadData.header_text = headerText.value;
        uploadData.approval_type = "Approval Instance";  
        uploadData.hide_exist_action = true;
        uploadData.sample_file_url = "/api/v2/approval_matrix/download";
    };
    const downloadFile = () => {
        const formData = new FormData();
        const ids = selected.value.map(item => item.id);
        ids.forEach(id => formData.append("ids[]", id));
        let url = "/api/v2/approval_matrix/download";
        proxy.$httpSecured.post(url, formData)
        .then(response => {
            if (response.data) {
                const url = response.data.url;
                const link = document.createElement("a");
                link.href = url;
                link.download = "";
                document.body.appendChild(link);
                link.click();
                snackbar.color = "success";
                snackbar.icon = "mdi-check-circle";
                snackbar.mode = "multi-line";
                snackbar.position = "top";
                snackbar.timeout = 3000;
                snackbar.title = "Success";
                snackbar.text = "(CSV File) Downloaded Successfully";
                snackbar.visible = true;
                selected.value = [];
                number.value = 0;
            } else {
                snackbar.color = "error";
                snackbar.icon = "mdi-close-circle";
                snackbar.mode = "multi-line";
                snackbar.position = "top";
                snackbar.timeout = 3000;
                snackbar.title = "Error";
                snackbar.text = "Something went wrong from Network";
                snackbar.visible = true;
            }
        })
        .catch(error => {
            snackbar.color = "error";
            snackbar.icon = "mdi-close-circle";
            snackbar.mode = "multi-line";
            snackbar.position = "top";
            snackbar.timeout = 3000;
            snackbar.title = "Error";
            snackbar.text = "Something went wrong from Network";
            snackbar.visible = true;
        });

    }
    const toTitleCase = (str) =>{
        if (str)
        return str.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    }

</script>
<style scoped>
.v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 320px) !important;
}
.approval-instance{
    padding: 15px;
    text-align: left;
    background-color: #f0f0f1;
}
</style>

